<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body">
            <div class="small-box">
                <div class="step-title">2. {{$t("Valjaanded")}}</div>
                <div class="help-block">{{$t("Millistes lehtedes soovid kuulutust avaldada")}}</div>

                <div class="custom-control custom-checkbox medium-back colored-border vertical-margin"
                     v-for="newspaper in allowedNewsPapers"
                    >
                    <input :id="newspaper.slug" :name="newspaper.slug" @change="saveState()"
                           class="custom-control-input"
                           type="checkbox"
                           v-model="newspaper.selected">
                    <label :for="newspaper.slug" class="custom-control-label"
                           v-bind:class="{'font-weight-bold':newspaper.selected}">{{newspaper.name[$i18n.locale]}}</label>
                </div>

                <div @change="toggleAll()" class="custom-control custom-checkbox m-1 vertical-margin">
                    <input class="custom-control-input" id="all-newspapers" type="checkbox"
                           v-model="selectAll">
                    <label class="custom-control-label" for="all-newspapers">{{$t('Vali koik')}}</label>
                </div>

                <a @click="changeStep('client')" class="btn btn-primary btn-block"
                   v-bind:class="{disabled: !formReady || storeIsLoading}">
                   <MoveForwardButton />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMainStore } from '../includes/store';
import MoveForwardButton from './MoveForwardButton.vue';
import { onMounted, onBeforeUpdate, onActivated, ref, computed, watch } from 'vue';

const store = useMainStore();

const newspapers = ref([]);
const selectAll = ref(false);

onMounted(() => {
    loadState();
    checkEmpty();
});

onActivated(() => {
    checkEmpty();
});

onBeforeUpdate(() => {
    checkEmpty();
});

const allowedPaper = (newspaper) => {
    if (!newspaper.ad_types) {
        newspaper.ad_types = "";
    }
    return newspaper.ad_types.split(',').includes(store.stepInfo.adType);
}

const changeStep = (step) => {
    saveState();
    store.changeStep(step);
}

const toggleAll = () => {
    for (let paper of newspapers.value) {
        paper.selected = selectAll.value;
    }
    saveState();
}

const loadState = () => {
    checkEmpty();
    getNewspapers();
}

const getNewspapers = () => {
    axios.get('/api/newspapers').then(result => {
        let newsPapersCopy = [];

        if (!Array.isArray(store.stepInfo.newspapers) || store.stepInfo.newspapers.length === 0) {
            result.data.forEach(p => {
                newsPapersCopy.push(p);
            });
        } else {
            store.stepInfo.newspapers.forEach((newsPaper) => {
                result.data.forEach(p => {
                    if (p.slug === newsPaper.slug) {
                        newsPaper.publish_dates = p.publish_dates;
                        newsPaper.ad_types = p.ad_types;
                        newsPaper.business_prices = p.business_prices;
                        newsPaper.lang = p.lang;
                        newsPaper.lock_hours = p.lock_hours;
                        newsPaper.private_prices = p.private_prices;
                        newsPaper.name = p.name;
                        newsPapersCopy.push(newsPaper);
                    }
                });
            });
            newspapers.value = newsPapersCopy;
        }
        newspapers.value = newsPapersCopy;
        store.setNewspapers(newsPapersCopy);
    });
}

const saveState = async () => {
    let allowedPapers = [];
    let allSelected = true;
    newspapers.value.forEach(paper => {
        if (!allowedPaper(paper)) {
            paper.selected = false;
        } else {
            if (!paper.selected) {
                allSelected = false;
            }
        }

        allowedPapers.push(paper);
    });
    console.log(allSelected);
    if (!allSelected) {
        selectAll.value = false;
    }
    newspapers.value = allowedPapers;
    store.setIsLoading(true);
    await axios.post('/state/newspapers', {
        state: newspapers.value
    }).then((response) => {
        console.log("Newspapers state changed");
    }).catch(_ => {
        store.sessExpired();
    });
    store.setIsLoading(false);
    store.setNewspapers(newspapers.value);
}

const checkEmpty = () => {
    if (!store.stateLoaded) {
        return;
    }
    if (store.step === "newspapers" && !store.stepInfo.adType) {
        store.changeStep('adType');
    }
}

const formReady = computed(() => {
    let ready = false;
    for (let paper of newspapers.value) {
        if (paper.selected) {
            ready = true;
        }
    }
    return ready;
})

const storeIsLoading = computed(() => {
    return store.isLoading;
})

const allowedNewsPapers = computed(() => {
    let allowed = [];
    newspapers.value.forEach(paper => {
        if (allowedPaper(paper)) {
            allowed.push(paper);
        }
    });
    return allowed;
})

watch(() => store.stateLoaded, (loaded) => {
    if (loaded) {
        loadState();
    }
}, { immediate: true });

</script>
